// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ServicesIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ServicesIcon" ref={forwardedRef} {...props}>
      <path d="M4.92 9.167a.5.5 0 0 1 .459 0L8.92 11a.5.5 0 0 1 .27.444v4.08a.5.5 0 0 1-.276.447l-3.538 1.773a.5.5 0 0 1-.448 0l-3.537-1.773a.5.5 0 0 1-.276-.447v-4.09a.5.5 0 0 1 .27-.445zm-2.554 3.355v2.54l2.162 1.083v-2.539zm3.412 3.623 2.163-1.084V12.53l-2.163 1.078zm-.624-3.623 2.032-1.012-2.038-1.054-2.028 1.046z" />
      <path d="M9.728 1.245a.5.5 0 0 1 .46 0l3.542 1.833A.5.5 0 0 1 14 3.522v4.08a.5.5 0 0 1-.276.447l-3.538 1.774a.5.5 0 0 1-.448 0L6.2 8.049a.5.5 0 0 1-.276-.447v-4.09a.5.5 0 0 1 .27-.444zM7.175 4.601v2.538l2.162 1.084V5.685zm3.412 3.623 2.163-1.085V4.61l-2.163 1.077zM9.963 4.6l2.032-1.012-2.038-1.054L7.928 3.58z" />
      <path d="M14.688 9.167a.5.5 0 0 1 .459 0L18.689 11a.5.5 0 0 1 .27.444v4.08a.5.5 0 0 1-.276.447l-3.538 1.774a.5.5 0 0 1-.448 0L11.16 15.97a.5.5 0 0 1-.276-.447v-4.09a.5.5 0 0 1 .27-.444zm-2.554 3.356v2.538l2.162 1.084v-2.538zm3.412 3.623 2.163-1.085v-2.53l-2.163 1.077zm-.624-3.624 2.032-1.012-2.038-1.054-2.028 1.046z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ServicesIcon = /* @__PURE__ */ Object.assign(
  ServicesIconComponent,
  { displayName: 'ServicesIcon' },
);
